<template>
  <section v-if="questionnaire.item" id="widget-form">
    <form
      v-on:submit.prevent="submitHandler"
      class="inputs d-flex flex-column"
      style="gap: 12px;"
    >
      <section
        v-if="questionnaire.item.is_public"
        class="inputs d-flex flex-column"
        style="gap: 12px;"
      >
        <div
          v-for="(question, index) in questionnaireQuestions"
          :key="`widget-question-${index}`"
          class="form-control d-flex align-top"
          style="gap: 12px;"
        >
          <CountryCodeSelector
            v-if="[ 7, 10 ].includes(question.question_type_id)"
            v-model="countryCode"
            width="130px"
          />
          <article class="flex-fill">
            <Select
              v-if="question.question_type_id === 2"
              v-show="question.show"
              :label="question.question"
              v-model="form[question.reference]"
              :placeholder="question.description"
              :items="question.filteredAnswers"
              item-text="answer"
              :disabled="!question.filteredAnswers.length"
              :required="question.is_required && question.show"
              :hide-details="!errorIndex(index)"
              :error-messages="errorMessaje(index)"
              :error="errorIndex(index)"
              @mounted="handleSelectedAnswer()"
              @change="handleSelectedAnswer()"
            />
            <div
              v-else-if="question.question_type_id === 11"
              v-show="question.answers.length === 2"
            >
              <span
                v-if="question.description"
                style="font-size: 15px;"
                v-html="question.description"
              ></span>
              <Checkbox
                v-model="form[question.reference]"
                :label="question.question"
                :error-messages="errorMessaje(index)"
                @change="validateFields(form[question.reference], question.question_type_id, index, question.is_required)"
              />
            </div>
            <TextField
              v-else
              v-model="form[question.reference]"
              :label="question.question"
              :placeholder="question.description"
              :required="question.is_required"
              :type="getInputType(question.question_type_id)"
              :hide-details="!errorIndex(index)"
              @keyup="validateIdentification(question.question_type_id, question.reference)"
              :error-messages="errorMessaje(index)"
              :error="errorIndex(index)"
              @blur="validateFields(form[question.reference], question.question_type_id, index, question.is_required)"
            />
          </article>
        </div>
      </section>
      <slot></slot>
      <slot name="actions" :sending-form="sendingForm"></slot>
    </form>
  </section>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapState, mapActions } from 'vuex'
import questionnaireServices from '@/services/Questionnary'
import Zoho from '@/plugins/zoho/Zoho'

require('@/plugins/dynamics365/indumotora/Cotization')
require('@/plugins/FormErrorValidator')

@Component({
  components: {
    CountryCodeSelector: () => import('@/components/elements/widget-form/elements/CountryCodeSelector.vue'),
    TextField: () => import('@/components/ui/TextField.vue'),
    Checkbox: () => import('@/components/ui/Checkbox.vue'),
    Select: () => import('@/components/ui/Select.vue')
  },
  data() {
    return {
      form: {},
      countryCode: null,
      termsAccepted: false,
      rutError: false,
      validateEmail: false,
      validateError: {},
      sendingForm: false
    }
  },
  watch: {
    customer: {
      handler() {
        this.initFormState()
      }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    questionnaireCode: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      questionnaire: state => state.questionnary,
      customer: state => state.storage?.room?.customer ?? {}
    }),
    questionnaireQuestions () {
      return this.questionnaire.item?.questions.filter((question) => question.is_public && question.answers.length) ?? []
    }
  },
  methods: {
    ...mapActions({
      setQuestionnaireItem: 'setQuestionnaireItem',
      setStorageRoomCustomer: 'setStorageRoomCustomer',
      setQuestionnaireQuestionFilteredAnswers: 'setQuestionnaireQuestionFilteredAnswers',
      setQuestionnaireQuestionShow: 'setQuestionnaireQuestionShow',
    })
  }
})
export default class WidgetForm extends Vue {
  validateIdentification (typeId, reference) {
    let value = this.form[reference]

    if (!value) {
      return false
    }

    let length = value.length

    if (typeId === 9 && value && length > 2) {
      if (value.split('-')) {
        value = value.split('-').join('')
        length = value.length
      }
      let lastCharacter = value.slice(-1)

      if (lastCharacter === 'k') {
        lastCharacter = 'K'
      }
      const newValue =  `${value.slice(0, (length - 1))}-${lastCharacter}`
      this.$set(this.form, reference, newValue)
      this.rutError = false
    }
  }

  errorMessaje (index) {
    if (this.validateError[index]?.error) return this.validateError[index]?.message
  }

  errorIndex (index) {
    return this.validateError[index]?.error
  }

  validateFields (value, typeId, index, required) {
    if (!value && !required) {
      this.$set(this.validateError, index, { error: false, message: null })
      return false
    } else if (typeId === 10) {
      value = `${this.countryCode}${value}`
    }

    let { error, message } = this.$FormErrorValidator.validateFields(value, typeId);

    if (typeId == 9) {
      this.rutError = error
    }

    this.$set(this.validateError, index, { error, message })
  }

  validateBeforeSubmit () {
    for (let index=0; index < (Object.keys(this.questionnaireQuestions)).length; index++) {
      const question = this.questionnaireQuestions[index]
      const isRequired = this.questionnaire.item.is_public && question.is_required && question.show

      this.validateFields(this.form[question.reference], question.question_type_id, index, isRequired)
    }

    for (let key in this.validateError) {
      if (this.validateError[key] && this.validateError[key]?.error) {
        return true
      }
    }

    return false
  }

  getInputType (typeId) {
    const typeMap = {
      3: 'text',
      4: 'text',
      7: 'tel',
      5: 'email'
    };

    return typeMap[typeId] || null;
  }

  getSessionAnswers () {
    const answers = Object.keys(this.form)

    const sessionAnswers = answers.map((answer, index) => {
      const question = this.questionnaireQuestions[index]
      const { id, question_type_id, reference, answers } = question
      const value = this.form[answer] ?? null

      let answerText = value;
      if ([ 7, 10 ].includes(question_type_id)) {
        answerText = `${this.countryCode || ''}${value || ''}`
      } else if (question_type_id === 11) {
        answerText = value ? answers[0].answer : answers[1].answer
      }

      return {
        questionId: id,
        questionTypeId: question_type_id,
        answerId: answers[0].id,
        reference,
        answer: answerText
      }
    })

    this.setStorageRoomCustomer({
      ...this.form,
      countryCode: this.countryCode ?? '+56'
    })

    this.$storage.updateStorageData()

    return sessionAnswers
  }

  next () {
    if (this.$organization.dynamics365()) {
      this.$dynamics365.setCotization()
    }

    if (this.$organization.zoho()) {
      Zoho.storeZoho()
    }
  }

  submitHandler () {
    if (!this.questionnaire.item) {
      this.next()
      return false
    }

    if (this.rutError) {
      return false
    }

    if (this.validateBeforeSubmit()) return false

    this.sendingForm = true

    const sessionAnswers = this.getSessionAnswers()

    const saveMethod = this.questionnaireCode
      ? questionnaireServices.updateSessionAnswers(this.questionnaireCode, sessionAnswers)
      : questionnaireServices.storeSessionAnswers(sessionAnswers)

    saveMethod
      .then((response) => {
        const { data } = response

        if (data.statusCode === 0) {
          this.validateEmail = data.validationEmail
          this.$store.state.storage.form.code = data.questionnaryCode
          this.$storage.updateStorageData()

          this.$emit('onSuccess', {
            validateEmail: this.validateEmail,
            sessionAnswers,
            formData: this.form,
            questionnaireCode: this.questionnaireCode
          });

          this.next()
        } else if (data.statusCode === 11) {
          this.$emit('onError')

          this.$store.commit('notify', {
            color: 'warning',
            message: this.$t('maintenance.text')
          })
        }
      })
      .catch((error) => {
        this.$emit('onError', error)
      })
      .finally(() => {
        setTimeout(() => this.sendingForm = false, 500)
      })
  }

  initFormState () {
    const { is_public } = this.questionnaire.item

    this.questionnaireQuestions.forEach((question) => {
      const { reference, answers, question_type_id } = question

      const value = is_public && this.customer && this.customer[reference] ? this.customer[reference] : null

      if (question_type_id === 2) {
        const selectedAnswer = is_public && value ? value : null
        this.$set(this.form, reference, selectedAnswer)
      } else if (question_type_id === 11 && answers.length === 2) {
        this.form[reference] = this.customer[reference] ?? false
        this.$set(this.form, reference, typeof this.form[reference] === 'boolean' ? this.form[reference] : false)
      } else {
        this.$set(this.form, reference, value === 'null' ? null : value)
      }
    })
  }

  handleSelectedAnswer() {
    if (this._processingAnswers) return;
    this._processingAnswers = true;

    try {
      const selectQuestions = this.questionnaireQuestions.filter(
        question => question.question_type_id === 2
      );

      const questionsMap = selectQuestions.reduce((map, question) => {
        map[question.id] = question;
        return map;
      }, {});

      selectQuestions
        .filter(question => question.parent_id && questionsMap[question.parent_id])
        .forEach(question => {
          const { parent_id, answers, reference } = question;
          const parentQuestion = questionsMap[parent_id];

          if (!parentQuestion) return;

          const parentValue = this.form[parentQuestion.reference];

          if (!parentValue) {
            this.resetChildQuestion(question);
            return;
          }

          const parentAnswer = parentQuestion.answers.find(
            answer => answer.answer === parentValue
          );

          if (!parentAnswer) {
            this.resetChildQuestion(question);
            return;
          }

          const filteredAnswers = answers.filter(
            answer => answer.parent_id === parentAnswer.id
          );

          this.setQuestionAnswers(question, filteredAnswers);

          const currentValue = this.form[reference];
          if (currentValue && !filteredAnswers.some(answer => answer.answer === currentValue)) {
            this.$set(this.form, reference, null);
          }
        });
    } finally {
      this._processingAnswers = false;
    }
  }

  setQuestionAnswers(question, answers) {
    this.setQuestionnaireQuestionFilteredAnswers({
      questionId: question.id,
      answers
    });

    const questionParent = this.questionnaireQuestions.find(q => q.id === question.parent_id);
    const questionParentValue = questionParent ? this.form[questionParent.reference] : null;

    const show = answers.length > 0 &&
      (questionParent?.show ?? true) &&
      questionParentValue !== null;

    this.setQuestionnaireQuestionShow({
      questionId: question.id,
      show
    });

    if (question.id) {
      const currentValue = this.form[question.reference];
      if (!currentValue || !answers.some(answer => answer.answer === currentValue)) {
        this.$set(this.form, question.reference, null);
      }
    }
  }

  resetChildQuestion (question) {
    this.setQuestionAnswers(question, [])
    this.$set(this.form, question.reference, '')
    this.resetChildrenOf(question.id)
  }

  resetChildrenOf(parentId) {
    const children = this.questionnaireQuestions.filter(
      q => q.question_type_id === 2 && q.parent_id === parentId
    );

    children.forEach(childQuestion => {
      this.$set(this.form, childQuestion.reference, null);

      this.setQuestionnaireQuestionFilteredAnswers({
        questionId: childQuestion.id,
        answers: []
      });

      if (childQuestion.id !== parentId) {
        this.resetChildrenOf(childQuestion.id);
      }
    });
  }

  beforeMount() {
    this.setQuestionnaireItem(this.data)
    this.initFormState()
  }
}
</script>